// Convert blob URL to File object
export const blobUrlToFile = async (blobUrl: string, fileName: string): Promise<File> => {
  try {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    
    // Create a File object from the blob
    const file = new File([blob], fileName, { type: blob.type });
    return file;
  } catch (error) {
    console.error('Error converting blob URL to file:', error);
    throw new Error('Failed to convert image to file');
  }
}; 